import { render, staticRenderFns } from "./RateTab.vue?vue&type=template&id=19f0b235"
import script from "./RateTab.vue?vue&type=script&lang=js"
export * from "./RateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports